jQuery(function($){

	let table = new DataTable('.kd-datatable--js', {
		"bLengthChange" : false,
		"bInfo":false,  
	});

	$('.kd-products-carousel__slider--slickjs').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		prevArrow: '<button class="kd-arrow kd-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>',
		nextArrow: '<button class="kd-arrow kd-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>',
		dots: true,
		autoplay: true,
		autoplaySpeed: 7000,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 550,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	});

	$('.kd-industry-carousel__slider--slickjs').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		prevArrow: '<button class="kd-arrow kd-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>',
		nextArrow: '<button class="kd-arrow kd-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>',
		dots: true,
		autoplay: true,
		autoplaySpeed: 7000,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 550,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	});

	$('.kd-testimonials__slider--slickjs').slick({
		prevArrow: '<button class="kd-arrow kd-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>',
		nextArrow: '<button class="kd-arrow kd-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>',
		dots: true,
	});

	$('.kd-timeline .year').click(function(){
		var $obj = $(this);

		$obj.closest('.kd-timeline').find('.active').removeClass('active');

		$obj.addClass('active');

		$('#' + $obj.data('target')).addClass('active');
	});

	$(window).bind('scroll load', function() {

		scroll			= $(window).scrollTop();

		if (scroll >= 400) {
			$('.kd-back-to-top').addClass('active');
		} else {
			$('.kd-back-to-top').removeClass('active');
		}
		
	});

});